/**
 * Copyright (C) 2025 Viasat, Inc.
 * All rights reserved.
 * The information in this software is subject to change without notice and should not be construed as a commitment by Viasat, Inc.
 *
 * Viasat Proprietary
 * The Proprietary Information provided herein is proprietary to Viasat and
 * must be protected from further distribution and use. Disclosure to others,
 * use or copying without express written authorization of Viasat, is strictly prohibited.
 */
import React from 'react';

export const SvgAircraftIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg {...props} data-test="airborne__terminal__icon">
    <path d="m21.50682,16l0,-2l-8,-5l0,-5.5c0,-0.83 -0.67,-1.5 -1.5,-1.5s-1.5,0.67 -1.5,1.5l0,5.5l-8,5l0,2l8,-2.5l0,5.5l-2,1.5l0,1.5l3.5,-1l3.5,1l0,-1.5l-2,-1.5l0,-5.5l8,2.5z" />
    <path d="M0 0h24v24H0z" fill="none" />
  </svg>
);

export const SleighIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg version="1.1" id="Icons" xmlns="http://www.w3.org/2000/svg" 
    viewBox="0 0 85 85" transform="translate(12,11)" xmlSpace="preserve">
    <path d="M27,24c0.6,0,1-0.4,1-1c0-3.8,0.9-7.5,2.6-10.9l1.3-2.6c0.2-0.3,0.1-0.7,0-1C31.7,8.2,31.3,8,31,8c-4.1,0-7.9,2-10.3,5.3
      l-2.2,3.1c-0.7,1-1.8,1.5-2.9,1.5c-1.3,0-2.4-0.7-3.1-1.7c-1.2-2-3.4-3.3-5.7-3.3H6c-0.4,0-0.7,0.2-0.9,0.5c-0.2,0.3-0.2,0.7,0,1
      l5,9c0.2,0.3,0.5,0.5,0.9,0.5h1.5l-1.2,3l-5.8,0c-1,0-2-0.3-2.7-1C2.3,25.5,2,24.9,2,24.3s0.3-1.3,0.8-1.7c0.8-0.7,2.1-0.7,2.8,0
      c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4c-1.5-1.4-4-1.4-5.6,0c-0.9,0.8-1.4,2-1.4,3.2s0.5,2.3,1.4,3.2c1.1,1,2.5,1.5,3.9,1.5
      c0.1,0,0.1,0,0.2,0l6.4,0c0,0,0,0,0,0c0,0,0,0,0,0l13,0c0,0,0,0,0,0c0,0,0,0,0,0l5,0c0.6,0,1-0.4,1-1s-0.4-1-1-1l-4.3,0l-1.2-3H27z
      M23.5,27l-10,0l1.2-3h7.6L23.5,27z"/>
  </svg>
);

export const SvgGroundTerminalIconPath = (props: React.SVGProps<SVGGElement>) => (
  <g {...props}>
    <title>ground_terminal_custom-24px</title>
    <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="Ground_Terminals_Terminal_Detailview" transform="translate(-651.000000, -269.000000)">
        <g id="Group-15" transform="translate(492.000000, 104.000000)">
          <g id="ground_terminal_custom-24px" transform="translate(155.000000, 161.000000)">
            <polygon id="Path" points="0 0 50 0 50 50 0 50" />
            <path
              d="M9.04119615,40.9520833 C15.0557795,46.9666667 24.5141128,47.4104167 31.0536961,42.3104167 L7.68286281,18.9395833 C2.58286281,25.4791667 3.02661281,34.9375 9.04119615,40.9520833 M27.0766128,26.0416667 C27.0766128,24.3166667 25.6766128,22.9166667 23.9516128,22.9166667 C22.2245295,22.9166667 20.8266128,24.3166667 20.8266128,26.0416667 C20.8266128,27.76875 22.2245295,29.1666667 23.9516128,29.1666667 C25.6766128,29.1666667 27.0766128,27.76875 27.0766128,26.0416667 M20.8266128,12.5 L20.8266128,16.6666667 C27.7182795,16.6666667 33.3266128,22.275 33.3266128,29.1666667 L37.4932795,29.1666667 C37.4932795,19.9625 30.0307795,12.5 20.8266128,12.5 M45.8266128,29.1666667 L41.6599461,29.1666667 C41.6599461,17.6791667 32.3141128,8.33333333 20.8266128,8.33333333 L20.8266128,4.16666667 C34.6328628,4.16666667 45.8266128,15.3604167 45.8266128,29.1666667"
              fill="currentcolor"
            />
          </g>
        </g>
      </g>
    </g>
  </g>
);

export const SvgGroundTerminalIcon = (svgProps: React.SVGProps<SVGSVGElement>) => (
  <svg {...svgProps} viewBox="0 0 42 42" data-test="ground__terminal__icon">
    <SvgGroundTerminalIconPath />
  </svg>
);

export const SvgSpaceVehicleTerminalIconPath = (props: React.SVGProps<SVGGElement>) => (
  <g {...props}>
    <title>ground_terminal_custom-24px</title>

    <path d="M2 5.57188L5.57193 2L10.5712 7.00023L7.0003 10.5711L2 5.57188Z" fill="black" />
    <path d="M6.9996 13.4281L10.5715 17L17.0002 10.5714L13.4283 7.00053L6.9996 13.4281Z" fill="black" />
    <path d="M13.4288 16.9998L18.4281 22L22 18.4281L16.9997 13.4289L13.4288 16.9998Z" fill="black" />
    <path
      d="M7.71449 16.2862C8.84486 17.4166 9.03376 19.1166 8.3125 20.4551L3.54454 15.6872C4.883 14.9659 6.58412 15.1548 7.71449 16.2862Z"
      fill="black"
    />
  </g>
);

export const SvgSpaceVehicleerminalIcon = (svgProps: React.SVGProps<SVGSVGElement>) => (
  <svg {...svgProps} viewBox="0 0 24 24" data-test="space__vehicle__icon">
    <SvgSpaceVehicleTerminalIconPath />
  </svg>
);
export const signalQualitySvg = (signalValue: number) => {
  let svg = `<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="25" height="20" viewBox="0 0 30 30"
       style="margin-left:5px;">

      <line x1="0" y1="20" x2="0" y2="25" style="stroke:${signalValue > 0 ? '#5EA215' : '#465967'};stroke-width:5"  />
      <line x1="6" y1="15" x2="6" y2="25" style="stroke:${signalValue > 1 ? '#5EA215' : '#465967'};stroke-width:5"  />
      <line x1="12" y1="10" x2="12" y2="25" style="stroke:${signalValue > 2 ? '#5EA215' : '#465967'};stroke-width:5" />
      <line x1="18" y1="5" x2="18" y2="${signalValue === -1 ? '20' : '25'}"
       style="stroke:${signalValue > 3 ? '#5EA215' : '#465967'};stroke-width:5" />
      <line x1="24" y1="0" x2="24" y2="${signalValue === -1 ? '20' : '25'}"
      style="stroke:${signalValue > 4 ? '#5EA215' : '#465967'};stroke-width:5" />
      <circle cx="20" cy="19" r="${signalValue === -1 ? '7' : '0'}" stroke="#202E39" stroke-width="2" fill="#465967" />
      <line x1="20" y1="15" x2="20" y2="20" stroke="#202E39" stroke-width="${signalValue === -1 ? '1.5' : '0'}" />
      <line x1="20" y1="21" x2="20" y2="22.5" stroke="#202E39" stroke-width="${signalValue === -1 ? '1.5' : '0'}" />


    </svg>`;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg)}`;
};
